import { ToastVariant, type ToastVariantType } from '@tundr/ds-components';

export const getToastDurationByVariant = (
  variant: ToastVariantType,
): number => {
  switch (variant) {
    case ToastVariant.ERROR:
      return 10000; // 10s for errors
    default:
      return 7000; // 7s for info, success, and warning
  }
};
